import { render, staticRenderFns } from "./adsense.vue?vue&type=template&id=767e920b&scoped=true&"
import script from "./adsense.vue?vue&type=script&lang=js&"
export * from "./adsense.vue?vue&type=script&lang=js&"
import style0 from "./adsense.vue?vue&type=style&index=0&id=767e920b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767e920b",
  null
  
)

export default component.exports